import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {
  IMAGE_CLEAN,
  IMAGE_DELETED,
  IMAGE_RELOAD,
  IMAGE_UPLOAD
} from "../../image/constants/actionTypes";
import {TIMELINE_FETCH, TIMELINE_RESET} from "../constants/actionTypes";
import {
  IMAGE_PERMISSION_R,
  IMAGE_PERMISSION_RWE
} from "../../../shared/constants/image";
import moment from "moment/moment";
import {TYPE_IMAGE} from "../constants";

export const timelineReducer = (state = [], action) => {
  switch (action.type) {
    case IMAGE_UPLOAD:
      return [
        ...[
          {
            type: TYPE_IMAGE,
            ...action.payload,
            rights: IMAGE_PERMISSION_R,
            feedback: "",
            date: moment().format("YYYY-MM-DDTHH:mm:ssZ")
          }
        ],
        ...state
      ];
    case IMAGE_RELOAD:
      return [
        ...state.map((item) => {
          return item.image.url === action.url
            ? {
              ...item,
              image: {
                ...item.image,
                url: action.payload.url_prev,
                hash: action.payload.url
              },
              rights: IMAGE_PERMISSION_RWE,
            }
            : item
        })
      ];
    case TIMELINE_FETCH:
      return [
        ...state,
        ...action.payload
      ];
    case IMAGE_DELETED:
      return [
        ...state.filter((item) => {
          return item.image.hash !== action.payload.hash
        })
      ];
    case IMAGE_CLEAN:
      return [
        ...state.filter((item) => {
          return item.image.url !== action.payload.url
        })
      ];
    case USER_LOGGED_OUT:
    case TIMELINE_RESET:
      return [];
    default:
      return state;
  }
};
